import * as stateUtils from './state';
// import * as constants from '../constants';

// const nms = [ constants.NAMESPACE, 'store', 'mutations' ].join('/');
// const log = require('debug')('@mycure/vue-plugins/' + nms);

/// imports and local declarations
/**
 * @typedef {import('./state').default} State
 * @typedef {import('./state').ICD10Fixture} ICD10Fixture
 * @typedef {import('./state').PaginationOpts} PaginationOpts
 */

/**
 * @param {State} state
 * @param {Object} obj
 * @param {number} obj.total
 * @param {PaginationOpts} obj.paginationOpts
 * @param {ICD10Fixture[]} obj.items
 */
export function setICD10Fixtures (state, obj) {
  const { items, total, paginationOpts } = Object.assign({}, obj);
  state.icd10 = items || [];
  state.icd10Total = total || state.icd10.length;
  state.icd10PaginationOpts = Object.assign({}, stateUtils.DEFAULT_ICD10_PAGINATION_OPTS, paginationOpts);
}
